import React from 'react'

import { createSvgIcon } from './utils/create-svg-icon'

export const CirclePercentageIcon = createSvgIcon(
  <>
    <title>circle percentage</title>
    <g
      className="nc-icon-wrapper"
      fill="#222222"
      stroke="#222222"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeWidth="1"
      transform="translate(0.5 0.5)"
    >
      <circle
        cx="16"
        cy="16"
        fill="none"
        r="14"
        stroke="#222222"
        strokeMiterlimit="10"
      />{' '}
      <circle
        cx="11.5"
        cy="11.5"
        data-color="color-2"
        fill="none"
        r="2.5"
        strokeMiterlimit="10"
      />{' '}
      <circle
        cx="20.5"
        cy="20.5"
        data-color="color-2"
        fill="none"
        r="2.5"
        strokeMiterlimit="10"
      />{' '}
      <line
        data-color="color-2"
        fill="none"
        strokeMiterlimit="10"
        x1="10"
        x2="22"
        y1="22"
        y2="10"
      />
    </g>
  </>
)
